import React, { useEffect, useState } from "react";
import {
  customerLogin,
  verifyCustomerOtp,
  registerCustomer,
  forgotPassword,
  resetPassword
} from "../api/apiService";
import toast from "react-hot-toast";

import "./LoginModal.css";

const LoginModal = ({ show, onClose, logo }) => {

  const [telephone, setTelephone] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const [resetEmail, setResetEmail] = useState("");
  const [resetOtp, setResetOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");

  // ✅ FIXED: missing state added
  const [resetOtpSent, setResetOtpSent] = useState(false);

  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);

  const [isRegister, setIsRegister] = useState(false);

  const [registerData, setRegisterData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    telephone: "",
    password: "",
    confirm_password: "",
  });

  // TIMER EFFECT
  useEffect(() => {
    let interval;

    if (otpSent && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }

    return () => clearInterval(interval);
  }, [otpSent, timer]);

  if (!show) return null;

  // ================= LOGIN =================
  const handleLogin = async () => {
    setError("");

    const input = telephone.trim();

    if (!input) return setError("Please enter email or mobile number");
    if (!password) return setError("Please enter password");

    const mobileRegex = /^[6-9]\d{9}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!mobileRegex.test(input) && !emailRegex.test(input)) {
      return setError("Please enter a valid email or mobile number");
    }

    try {
      const res = await customerLogin({
        identifier: input,
        password,
      });

      if (res.status) {
        localStorage.setItem("session", JSON.stringify(res.data.customer));
        localStorage.setItem("token", res.data.token);

        onClose();
        window.location.href = "/checkout";
      } else {
        setError(res.message || "Login failed");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Server error. Please try again.");
    }
  };

  // ================= OTP VERIFY =================
  const handleVerifyOtp = async () => {
    setError("");

    if (!otp) return setError("Please enter OTP");
    if (otp.length !== 6) return setError("Please enter valid OTP");

    try {
      const res = await verifyCustomerOtp({
        telephone,
        otp,
      });

      if (res.status) {
        toast.success("OTP verified successfully. Please login.");

        setOtpSent(false);
        setIsRegister(false);
        setOtp("");
        setPassword("");
      } else {
        setError(res.message || "Invalid OTP");
      }
    } catch (err) {
      setError("OTP verification failed");
    }
  };

  // ================= RESEND OTP =================
  const handleResendOtp = async () => {
    setError("");

    try {
      const res = await customerLogin({
        telephone,
      });

      if (res.status) {
        setTimer(60);
        setCanResend(false);
        setOtp("");
      } else {
        setError(res.message);
      }
    } catch (err) {
      setError("Server error. Please try again.");
    }
  };

  // ================= REGISTER =================
  const handleRegister = async () => {
    //alert('dddd');
    setError("");

    const {
      first_name,
      last_name,
      email,
      telephone,
      password,
      confirm_password,
    } = registerData;

    if (!first_name || !last_name || !email || !telephone || !password || !confirm_password) {
      return setError("All fields are required");
    }

    if (password !== confirm_password) {
      return setError("Passwords do not match");
    }

    try {
      const res = await registerCustomer(registerData);

      if (res.status) {
        toast.success("Please check your email for OTP");

        setOtpSent(true);
        setIsRegister(false);

        setTelephone(registerData.telephone);

        setOtp("");
        setTimer(60);
        setCanResend(false);
      } else {
        setError(res.message);
      }
    } catch (err) {
      setError("Server Error");
    }
  };

  // ================= FORGOT PASSWORD OTP SEND =================
  const handleSendResetOtp = async () => {
    setError("");

    if (!resetEmail) {
      return setError("Please enter email");
    }

    try {
      const res = await forgotPassword({
        email: resetEmail,
      });

      if (res.status) {
        toast.success("OTP sent to your email");
        setResetOtpSent(true);
      } else {
        setError(res.message);
      }
    } catch (err) {
      setError("Server Error");
    }
  };

  // ================= RESET PASSWORD =================
  const handleResetPassword = async () => {
    setError("");

    if (!resetOtp) return setError("Please enter OTP");
    if (!newPassword) return setError("Please enter new password");

    try {
      const res = await resetPassword({
        email: resetEmail,
        otp: resetOtp,
        password: newPassword,
      });

      if (res.status) {
        toast.success("Password reset successfully");

        setShowForgotPassword(false);
        setResetOtpSent(false);

        setResetEmail("");
        setResetOtp("");
        setNewPassword("");
      } else {
        setError(res.message);
      }
    } catch (err) {
      setError("Server Error");
    }
  };



  return (

    <div className="custom-login-overlay">

      <div className="custom-login-modal">

        {/* LEFT SIDE */}
        <div className="login-left">

          <div className="login-brand">

            <img
              style={{ width: "200px" }}
              src={logo}
              alt="logo"
            />

            <h4>
              Welcome to Red Carat
            </h4>

            <p>
              India's Premium Jewellery Brand
            </p>

          </div>

          <div className="login-features">

            <div className="feature-card">

              <h6>
                Premium Jewellery
              </h6>

              <p>
                Luxury collections crafted for everyday elegance.
              </p>

            </div>

            <div className="feature-card">

              <h6>
                Exclusive Offers
              </h6>

              <p>
                Unlock member-only deals and rewards.
              </p>

            </div>

            <div className="feature-card">

              <h6>
                VIP Access
              </h6>

              <p>
                Early access to launches and private collections.
              </p>

            </div>

          </div>

        </div>

        {/* RIGHT SIDE */}
        <div className="login-right">

          <button
            className="login-close"
            onClick={onClose}
          >
            ✕
          </button>

          <h3 className="login-heading">
            Explore Red Carat
          </h3>

          <p className="login-subtitle">
            Affordable Luxury, Made for Every Day!
          </p>


          {/* MOBILE NUMBER SECTION */}
          {!isRegister && !otpSent && !showForgotPassword && (
            <>

              <div className="phone-input-wrapper">

                <input
                  type="text"
                  placeholder="Enter Email or Mobile Number"
                  className="phone-input"
                  value={telephone}
                  onChange={(e) => {
                    setTelephone(e.target.value.trim());
                    setError("");
                  }}
                />

              </div>
              <div className="phone-input-wrapper">

                <input
                  type="password"
                  placeholder="Enter Password"
                  className="phone-input"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setError("");
                  }}
                />

              </div>

              {error && (
                <div className="input-error">
                  {error}
                </div>
              )}

              <button
                className="submit-login-btn"
                onClick={handleLogin}
              >
                Login
              </button>
              <div
                style={{
                  marginTop: "10px",
                  cursor: "pointer",
                  color: "#c49b63",
                }}
                onClick={() =>
                  setShowForgotPassword(true)
                }
              >
                Forgot Password?
              </div>

            </>
          )}

          {/* OTP SECTION */}
          {otpSent && (
            <>

              <div className="phone-input-wrapper">

                <input
                  type="tel"
                  placeholder="Enter OTP"
                  className="phone-input"
                  value={otp}
                  maxLength={6}
                  onChange={(e) => {

                    const value = e.target.value.replace(/\D/g, "");

                    setOtp(value);

                    setError("");

                  }}
                />

              </div>

              {/* TIMER */}
              {!canResend && (

                <div
                  style={{
                    marginTop: "10px",
                    fontSize: "14px",
                    color: "#666",
                  }}
                >
                  OTP valid for{" "}

                  <strong>
                    00:{timer < 10 ? `0${timer}` : timer}
                  </strong>

                </div>

              )}

              {/* RESEND OTP */}
              {canResend && (

                <div
                  style={{
                    marginTop: "10px",
                    fontSize: "14px",
                  }}
                >

                  Didn't receive OTP?{" "}

                  <span
                    onClick={handleResendOtp}
                    style={{
                      color: "#c49b63",
                      cursor: "pointer",
                      fontWeight: "600",
                    }}
                  >
                    Resend OTP
                  </span>

                </div>

              )}

              {error && (
                <div className="input-error">
                  {error}
                </div>
              )}

              <button
                className="submit-login-btn"
                onClick={handleVerifyOtp}
              >
                Verify OTP
              </button>

            </>
          )}
          {showForgotPassword && (
            <>
              <h5 style={{ marginBottom: "20px" }}>
                Reset Password
              </h5>

              {/* Email */}
              <div className="phone-input-wrapper">
                <input
                  type="email"
                  placeholder="Enter Email Address"
                  className="phone-input"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                />
              </div>

              {/* OTP Field */}
              {resetOtpSent && (
                <>
                  <div className="phone-input-wrapper">
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      className="phone-input"
                      value={resetOtp}
                      onChange={(e) => setResetOtp(e.target.value)}
                    />
                  </div>

                  <div className="phone-input-wrapper">
                    <input
                      type="password"
                      placeholder="Enter New Password"
                      className="phone-input"
                      value={newPassword}
                      onChange={(e) =>
                        setNewPassword(e.target.value)
                      }
                    />
                  </div>
                </>
              )}

              {error && (
                <div className="input-error">
                  {error}
                </div>
              )}

              {!resetOtpSent ? (
                <button
                  className="submit-login-btn"
                  onClick={handleSendResetOtp}
                >
                  Send OTP
                </button>
              ) : (
                <button
                  className="submit-login-btn"
                  onClick={handleResetPassword}
                >
                  Reset Password
                </button>
              )}

              <div
                style={{
                  marginTop: "15px",
                  textAlign: "center",
                  cursor: "pointer",
                  color: "#c49b63",
                  fontWeight: "600",
                }}
                onClick={() => {
                  setShowForgotPassword(false);
                  setResetOtpSent(false);
                  setResetEmail("");
                  setResetOtp("");
                  setNewPassword("");
                  setError("");
                }}
              >
                Back to Login
              </div>
            </>
          )}
          {isRegister && (
            <>
              <div className="register-grid">

                <input
                  type="text"
                  placeholder="First Name"
                  value={registerData.first_name}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      first_name: e.target.value,
                    })
                  }
                />

                <input
                  type="text"
                  placeholder="Last Name"
                  value={registerData.last_name}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      last_name: e.target.value,
                    })
                  }
                />

                <input
                  type="email"
                  placeholder="Email Address"
                  value={registerData.email}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      email: e.target.value,
                    })
                  }
                />

                <input
                  type="tel"
                  placeholder="Phone Number"
                  value={registerData.telephone}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      telephone: e.target.value,
                    })
                  }
                />

                <input
                  type="password"
                  placeholder="Password"
                  value={registerData.password}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      password: e.target.value,
                    })
                  }
                />

                <input
                  type="password"
                  placeholder="Confirm Password"
                  value={registerData.confirm_password}
                  onChange={(e) =>
                    setRegisterData({
                      ...registerData,
                      confirm_password: e.target.value,
                    })
                  }
                />

              </div>

              {error && (
                <div className="input-error">{error}</div>
              )}

              <button
                className="submit-login-btn"
                onClick={handleRegister}
              >
                Create Account
              </button>
            </>
          )}
          {/* NOTIFY CHECKBOX */}
          <div
            style={{
              textAlign: "center",
              marginTop: "15px",
            }}
          >
            {!isRegister ? (
              <>
                Don't have an account?{" "}
                <span
                  style={{
                    color: "#c49b63",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                  onClick={() => {
                    setIsRegister(true);
                    setOtpSent(false);
                    setShowForgotPassword(false);
                    setError("");
                  }}
                >
                  Create Account
                </span>
              </>
            ) : (
              <>
                Already have an account?{" "}
                <span
                  style={{
                    color: "#c49b63",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                  onClick={() => {
                    setIsRegister(false);
                    setError("");
                  }}
                >
                  Login
                </span>
              </>
            )}
          </div>

          {/* FOOTER */}
          <div className="login-footer">

            I accept the Privacy Policy and Terms & Conditions.

          </div>

        </div>

      </div>

    </div>

  );
};

export default LoginModal;